<template>
    <div class="content-card mb-4">
        <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
            รายชื่อสมาชิกทั้งหมด
            <!-- <button class="btn btn-outline-primary btn-filter btn-active"><i
                    class="fa-icon fa-solid fa-circle-check me-2"></i>รายชื่อสมาชิกทั้งหมด</button> -->
            <!-- <button class="btn btn-outline-secondary btn-filter"><i
                    class="fa-icon fa-solid fa-circle me-2"></i>รายได้สมาชิกต่อวัน</button> -->
        </div>
        <div class="content-card-body ">
            <div class="table-responsive text-nowrap">
                <table class="datatable table table-bordered table-sm" id="invitemembers">
                    <thead>
                        <tr>
                            <th style="min-width:320px;">ยูสเซอร์เนม</th>
                            <th style="width:160px;" class="totalbet text-center"><span>แทงทั้งหมด</span></th>
                            <th style="width:160px;" class="datetime text-center">
                                <span>วัน-เวลา</span><span>ที่สมัคร</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="listFriend.length > 0">
                            <tr class="" v-for="(item, index) in pageOfItems" :key="index">
                                <td>{{ filterName(item.userName) }}</td>
                                <td class="totalbet text-end">{{ numberWithCommas(item.commitionValue) }}</td>
                                <td class="datetime text-end">{{ item.dateRegister }}</td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="3" class="text-center">
                                <span class="text-primary" v-if="listFriend.length === 0">ไม่มีรายการ</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <jw-pagination :items="listFriend" @changePage="onChangePage"></jw-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { findAllFriendAffiliateService } from '@/services'
import JwPagination from 'jw-vue-pagination'
// Test pagination
const exampleItems = [...Array(50).keys()].map(i => ({ dateRegister: (i + 1), userName: 'Item ' + (i + 1), commitionValue: 'Flintstone' }))
export default {
  components: { JwPagination },
  async created () {
    this.setLoading(true)
    const resp = await findAllFriendAffiliateService()
    if (resp.status_code === 'SUCCESS') {
      this.listFriend = resp.data.listFriend
    }
    this.setLoading(false)
  },
  data: () => {
    return {
      listFriend: [],
      pageOfItems: [],
      exampleItems
    }
  },
  methods: {
    ...mapActions(['setLoading']),
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    numberWithCommas (n) {
      const x = Number(n)
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    filterName (val) {
      const strAr = val.split('')
      let ret = ''
      strAr.forEach((value, index) => {
        if (index > 1 && index < (val.length - 2)) {
          ret = ret + '*'
        } else {
          ret = ret + value
        }
      })
      return ret
    }
  }
}
</script>
